/**
 * Gestion personnalisé du dépot de fichier avec drag & drop
 */
const allowedTypes = [
	'application/pdf',           // PDF
	'text/plain',                // TXT
	'application/msword',        // DOC
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
	'application/vnd.oasis.opendocument.text', // ODT
	'application/rtf',           // RTF
	'application/vnd.oasis.opendocument.spreadsheet', // ODS
];

function filterFiles(files, allowedTypes) {
	return Array.from(files).filter(file => allowedTypes.includes(file.type));
}

function createFileList(files) {
	const dataTransfer = new DataTransfer();
	files.forEach(file => dataTransfer.items.add(file));
	return dataTransfer.files;
}

function unslugify(slug) {
	return slug
		.replace(/-/g, ' ')                // remplace les tirets par des espaces
		.replace(/\b\w/g, c => c.toUpperCase()); // met en majuscule chaque mot
}

export function initDragDropUploads() {
	const formItems = document.querySelectorAll('.form__item');

	formItems.forEach(formItem => {
		const input = formItem.querySelector('input[type="file"]');
		// const spanFiles = formItem.querySelector('.form__item-files');

		if (!input) return;

		formItem.addEventListener('dragover', e => {
			e.preventDefault();
			input.classList.add('dragover');
		});

		formItem.addEventListener('dragleave', () => {
			input.classList.remove('dragover');
		});

		formItem.addEventListener('drop', e => {
			e.preventDefault();
			input.classList.remove('dragover');

			const validFiles = filterFiles(e.dataTransfer.files, allowedTypes);
			input.files = createFileList(validFiles);

			// Mise à jour du label si présent
			// if (spanFiles) {
			// 	const fileList = Array.from(files).map(f => f.name).join(', ');
			// 	spanFiles.textContent = `Fichiers : ${fileList}`;
			// }
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initDragDropUploads();
});


/**
 * Si l'URL contient le "job-title" et le "job-site" on les affiche et on complète les champs cachés.
 */
export function initJobParams() {
	// const isJobForm = document.querySelector('[data-wpcf7-id="1021"]');
	const isJobForm = document.querySelectorAll('[data-wpcf7-id="1021"], [data-wpcf7-id="2375"]');
	if (isJobForm.length === 0) return;

	const jobParams = new URLSearchParams(window.location.search);

	const jobTitleParam = jobParams.get('job-title');
	const jobSiteParam = jobParams.get('job-site');

	if (!jobTitleParam && !jobSiteParam) {
		const jobCustomString = document.querySelector('.form__job');
		console.warn('Il n\'y a pas de paramètres job-title et job-site dans l\'URL.');
		if (jobCustomString) jobCustomString.style.display = 'none';
	}

	const jobTitle = unslugify(decodeURIComponent(jobTitleParam));
	const jobSite = unslugify(decodeURIComponent(jobSiteParam));

	// Boucle sur chaque formulaire trouvé
	isJobForm.forEach(form => {
		const spanTitle = form.querySelector('#job_title');
		const spanSite = form.querySelector('#job_site');
		const inputTitle = form.querySelector('#job-title');
		const inputSite = form.querySelector('#job-site');

		// Affichage dans les <span> au dessus du formulaire
		if (spanTitle && jobTitleParam) spanTitle.textContent = jobTitle;
		if (spanSite && jobSiteParam) spanSite.textContent = jobSite;

		// Affichage dans les champs cachés du formulaire
		if (inputTitle && jobTitleParam) inputTitle.value = jobTitle;
		if (inputSite && jobSiteParam) inputSite.value = jobSite;
	});

}
document.addEventListener('DOMContentLoaded', () => {
	initJobParams()
});


/**
 * Cacher le formulaire s'il est envoyé
 */
document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('wpcf7submit', function (e) {
		const form = e.target;
		const response = form.querySelector('.wpcf7-response-output');

		if (!response) return;

		// Vérifie si le message est une confirmation (classe .wpcf7-mail-sent-ok)
		if (response.classList.contains('wpcf7-mail-sent-ok')) {
			form.style.display = 'none';
		}

		// Si erreur, on laisse le formulaire visible
	}, false);
});